<div class="main-container text-center">
  <div class="header">
    <h1 class="title" id="home-title">
      {{ "dashboard.title" | translate }}
    </h1>
    <h2 class="subtitle">{{ "dashboard.subtitle" | translate }}</h2>
  </div>
  <div class="flex-container">
    <app-navigation-element
      *ngIf="canImportData"
      [route]="'/home/upload'"
      [title]="'navigation.uploadData.title'"
      [subtitle]="'navigation.uploadData.subtitle'"
      [icon]="'upload'"
    >
    </app-navigation-element>
    <app-navigation-element
      [route]="'/home/samples'"
      [title]="'navigation.samples.title'"
      [subtitle]="'navigation.samples.subtitle'"
      [icon]="'file-text'"
    >
    </app-navigation-element>
    <app-navigation-element
      *ngIf="canOpenGrafana"
      [title]="'navigation.analytics.title'"
      [subtitle]="'navigation.analytics.subtitle'"
      [icon]="'chart-column'"
      [opensNewTab]="true"
      (selected)="openGrafana()"
    >
    </app-navigation-element>
    <app-navigation-element
      *ngIf="canAccessAdministration"
      [route]="'/administration'"
      [title]="canViewAllOrganizations ? 'navigation.administration.superAdmin.title' : 'navigation.administration.admin.title'"
      [subtitle]="canViewAllOrganizations ? 'navigation.administration.superAdmin.subtitle' : 'navigation.administration.admin.subtitle'"
      [icon]="'settings'"
    >
    </app-navigation-element>
  </div>
</div>
